export class ImageUploadSelectors {
  // Basic state selectors
  static getUploadedImages = (state: any) => state?.imageUpload?.uploadedImages || [];
  static isUploadInProgress = (state: any) => state?.imageUpload?.isUploadInProgress || false;
  static isScanInProgress = (state: any) => state?.imageUpload?.isScanInProgress || false;
  static getError = (state: any) => state?.imageUpload?.error || null;
  static getCurrentUpload = (state: any) => state?.imageUpload?.currentUpload || null;
  static getLastUploadedImage = (state: any) => state?.imageUpload?.lastUploadedImage || null;

  // Computed selectors
  static getUploadedImagesCount = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).length;

  static getSuccessfulUploads = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).filter((img: any) => img.status === 'completed');

  static getFailedUploads = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).filter((img: any) => img.status === 'failed');

  static getUploadingImages = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).filter((img: any) => img.uploading);

  static getScanningImages = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).filter((img: any) => img.status === 'scanning');

  static getImageByKey = (imageKey: string) => (state: any) => 
    (state?.imageUpload?.uploadedImages || []).find((img: any) => img.s3Key === imageKey);

  static getImagesWithResults = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).filter((img: any) => img.scanResult);

  static getTotalFileSize = (state: any) => 
    (state?.imageUpload?.uploadedImages || []).reduce((total: number, img: any) => total + (img.size || 0), 0);

  static getAverageFileSize = (state: any) => {
    const images = state?.imageUpload?.uploadedImages || [];
    if (images.length === 0) return 0;
    const totalSize = images.reduce((total: number, img: any) => total + (img.size || 0), 0);
    return totalSize / images.length;
  };

  static getUploadStats = (state: any) => {
    const images = state?.imageUpload?.uploadedImages || [];
    const total = images.length;
    const successful = images.filter((img: any) => img.status === 'completed').length;
    const failed = images.filter((img: any) => img.status === 'failed').length;
    const uploading = images.filter((img: any) => img.uploading).length;
    const scanning = images.filter((img: any) => img.status === 'scanning').length;

    return {
      total,
      successful,
      failed,
      uploading,
      scanning,
      successRate: total > 0 ? (successful / total) * 100 : 0,
    };
  };
} 